import { StageTenApiVersions } from "client/packages/sdk/SdkTypes"

export interface Params {
  channelId: string
  forceHLS: boolean
  fs: boolean
  branding?: string
  accentColor?: string
  fullscreenFallback: boolean
  recordingId?: string
  assetId?: string
  apiVersion?: keyof typeof StageTenApiVersions
}

export type QueryParams = Partial<{
  [P in keyof Params]: string
}>

// QueryParams is the raw params object so all keys are optional. However,
// once we get into the app we don't want most of these values to be optional,
// so we parse this into the Params object which treats most values as required
export function parseQueryParams(params: QueryParams): Params {
  const parsedParams: Params = {
    channelId: params.channelId ?? "",
    forceHLS: params.forceHLS === "true",
    fs: params.fs === "true",
    branding: params.branding,
    accentColor: params.accentColor,
    fullscreenFallback: params.fullscreenFallback !== "false",
    recordingId: params.recordingId,
    apiVersion:
      params.apiVersion && params.apiVersion in StageTenApiVersions
        ? (params.apiVersion as keyof typeof StageTenApiVersions)
        : undefined,
    assetId: params.assetId,
  }

  return parsedParams
}
